export const TOKEN_KEY = 'token'
export const USER_KEY = 'user'
export const REFRESH_TOKEN_KEY = 'refreshToken'
